export default __webpack_public_path__ + "static/media/people.b3c5c3f3.svg";